import React, { Component } from "react";
import PropTypes from "prop-types";
import { ModalContainer, ModalDialog } from "react-modal-dialog";
import { connect } from "react-redux";
import actions from "actions";
import constants from "constants";
import Quiz from "containers/Quiz/Quiz";
import MobileNavbar from "containers/Navbar/MobileNavbar";
import UsersPopup from "containers/Dashboard/UsersPopup";
import UsersPopupNewWebinar from "containers/Admin/Webinar/UsersPopupNewWebinar";
import ConfirmationModal from "containers/Admin/ConfirmationModal";
import StatsUsersPopup from "containers/StatsLocker/UsersPopup";
import CourseMaterialModal from "../../components/Admin/StudyGroups/CourseMaterials/CourseMaterialModal";
import UserLeaveGroupModal from "../Admin/UserLeaveGroupModal";
import AddToCalendarModal from "../AddToCalendarModal";

const { hideModal, createCourseMaterial, updateCourseMaterial } = actions;

const {
  MODAL_TYPE_QUIZ,
  MODAL_TYPE_NAVBAR,
  MODAL_TYPE_DASHBOARD,
  MODAL_TYPE_DELETE_CONFIRMATION,
  MODAL_TYPE_WEBINAR,
  MODAL_TYPE_STATS,
  MODAL_TYPE_COURSE_MATERIAL,
  MODAL_TYPE_USER_LEAVE_GROUP,
  MODAL_ADD_TO_CALENDAR,
} = constants;

class Modal extends Component {
  static propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
    dispatch: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);
  }

  modalContent = () => {
    const {
      modalType,
      modalContentProps,
      hideModal,
      users,
      createCourseMaterial,
      updateCourseMaterial,
    } = this.props;

    switch (modalType) {
      case MODAL_TYPE_QUIZ:
        return <Quiz {...modalContentProps} />;
      case MODAL_TYPE_NAVBAR:
        return <MobileNavbar modalHide={hideModal} />;
      case MODAL_TYPE_DASHBOARD:
        return (
          <UsersPopup modalHide={hideModal} users={modalContentProps.users} />
        );
      case MODAL_TYPE_WEBINAR:
        return (
          <UsersPopupNewWebinar
            modalHide={hideModal}
            users={modalContentProps.users}
          />
        );
      case MODAL_TYPE_DELETE_CONFIRMATION:
        return <ConfirmationModal />;
      case MODAL_TYPE_USER_LEAVE_GROUP:
        return <UserLeaveGroupModal />;
      case MODAL_ADD_TO_CALENDAR:
        return <AddToCalendarModal />;
      case MODAL_TYPE_STATS:
        return <StatsUsersPopup modalHide={hideModal} users={users} />;
      case MODAL_TYPE_COURSE_MATERIAL:
        return (
          <CourseMaterialModal
            modalHide={hideModal}
            material={modalContentProps.material}
            createCourseMaterial={createCourseMaterial}
            updateCourseMaterial={updateCourseMaterial}
          />
        );
      default:
        return null;
    }
  };

  isDialogShowed = () => this.props.modalType != MODAL_TYPE_NAVBAR;

  className = () =>
    this.props.modalType == MODAL_TYPE_DASHBOARD ? "dashboard_modal" : "";

  render() {
    const { modalType } = this.props;

    if (!modalType) return null;

    return (
      <ModalContainer onClose={this.props.hideModal}>
        <div className={this.className()}>
          {this.isDialogShowed() ? (
            <ModalDialog
              onClose={this.props.hideModal}
              style={{ width: "500px" }}
            >
              <div className="modal-close">
                <a
                  onClick={this.props.hideModal}
                  href="javascript:void(0)"
                  className="modal_test_close modal-action modal-close"
                  style={{ zIndex: 100 }}
                >
                  <img src="/assets/img/close.png" alt="close" />
                </a>
              </div>
              <this.modalContent />
            </ModalDialog>
          ) : (
            <this.modalContent />
          )}
        </div>
      </ModalContainer>
    );
  }
}

const mapStateToProps = (state) => ({
  modalType: state.modal.modalType,
  modalContentProps: state.modal.modalContentProps,
  users: state.stats.users,
});

const mapDispatchToProps = (dispatch) => ({
  dispatch,
  hideModal: () => dispatch(hideModal()),
  createCourseMaterial: (courseMaterial) =>
    dispatch(createCourseMaterial(courseMaterial)),
  updateCourseMaterial: (courseMaterial) =>
    dispatch(updateCourseMaterial(courseMaterial)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Modal);



// WEBPACK FOOTER //
// ./src/containers/Modal/Modal.jsx